<template lang="pug">
  transition(v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter" v-on:before-leave="beforeLeave" v-on:leave="leave" v-bind:css="false" appear)
    .FullscreenImgViewer(@click="clickHandler" @mouseenter="captureCursor")
      .FullscreenImgViewer_bg(ref="bg")
      img(:src="currentSrc" ref="img").FullscreenImgViewer_img

      div.Zoomable_cursor(ref="cursor")
        span
        span

</template>

<script>

// TODO - FIX : prevent panning bug on mobile !

export default {
  props: {
    src: {
      type: String,
      required: true
    },
    thumbEl: {
      // type: HTMLDivElement,
      required: true
    }
  },
  data () {
    return {
      currentSrc: this.thumbEl ? this.thumbEl.src : null, // src de l'image (par défaut celle de la thumbnail avant chargement de l'image hd)
      thumbRect: null, // DOMRect de la thumbnail
      imgRect: null, // DOMRect de l'image
      elRect: null, // DOMRect du composant
      mousePos: null, // point de position {x, y} de la souris
      unmounted: false, // sert à savoir si l'élément a été détruit (utile dans les callbacks asynchrones)
      isDraging: false, // permet de savoir si on est en train de dragger l'image
      imgRatio: 0
    }
  },
  computed: {
    ratio () {
      return this.imgRatio || this.thumbRatio
    },
    // ratio de la thumbnail
    thumbRatio () {
      return this.thumbRect.height / this.thumbRect.width
    },
    // ratio de l'élement root
    elRatio () {
      return this.elRect ? this.elRect.height / this.elRect.width : null
    },
    // largeur de l'image fullscreen
    imgWidth () {
      if (this.elRatio && this.ratio && this.elRect) {
        return this.elRatio < this.ratio ? this.elRect.width : this.elRect.height / this.ratio
      } else {
        return 0
      }
    },
    // hauteur de l'image fullscreen
    imgHeight () {
      if (this.elRatio && this.ratio && this.elRect) {
        return this.elRatio < this.ratio ? this.elRect.width * this.ratio : this.elRect.height
      } else {
        return 0
      }
    },
    // Position locale de la souris en pixel
    localMousePos () {
      if (this.mousePos && this.elRect) {
        return {
          x: this.mousePos.x - this.elRect.left,
          y: this.mousePos.y - this.elRect.top
        }
      } else {
        return null
      }
    },
    // Position locale de la souris en ratio (0 - 1)
    localMousePosRatio () {
      if (this.localMousePos && this.elRect) {
        return {
          x: this.localMousePos.x / this.elRect.width,
          y: this.localMousePos.y / this.elRect.height
        }
      } else {
        return null
      }
    },
    // Point définissant la position de l'image en fonction des mouvements de la souris
    imgPosFromMousePos () {
      if (this.localMousePosRatio && this.elRect && this.imgRect) {
        return {
          x: (this.elRect.width - this.imgRect.width) * this.localMousePosRatio.x,
          y: (this.elRect.height - this.imgRect.height) * this.localMousePosRatio.y
        }
      } else {
        return null
      }
    }
  },
  watch: {
    imgPosFromMousePos () {
      if (this.imgPosFromMousePos) {
        // On replace l'image correctement en fonction des mouvements de souris
        TweenLite.to(this.$refs.img, 0.8, {
          top: this.imgPosFromMousePos.y,
          left: this.imgPosFromMousePos.x
        })
      } else {
        // On arrête l'animation s'il n'y a plus de position de souris
        TweenLite.killTweensOf(this.$refs.img, {top: true, left: true})
      }
    }
  },
  created () {
    // On charge l'image HD
    this._hdImgLoader = new Image()
    this._hdImgLoader.addEventListener('load', this.hdImgLoadedHandler)
    this._hdImgLoader.src = this.src
  },
  mounted () {
    this.cacheData()

    // On écoute les évènement de clavier
    window.addEventListener('keydown', this.keydownHandler)
    // On écoute les évènement de resize
    window.addEventListener('resize', this.windowResizeHandler)
    window.addEventListener('orientationchange', this.windowResizeHandler)
    this.addCursor()
  },
  beforeDestroy () {
    // On sauvegarde le fait que le composant a été unmounted
    this.unmounted = true

    this.removeCursor()

    // On arrête d'écouter tous les évènements
    if (this._hdImgLoader) {
      this._hdImgLoader.removeEventListener('load', this.hdImgLoadedHandler)
    }
    window.removeEventListener('keydown', this.keydownHandler)
    window.removeEventListener('mousemove', this.mouseMoveHandler)
    window.removeEventListener('resize', this.windowResizeHandler)
    window.removeEventListener('orientationchange', this.windowResizeHandler)
    window.removeEventListener('captureCursor', this.captureCursor)
  },
  methods: {
    addCursor () {
      if (!!('ontouchstart' in window) || !!('onmsgesturechange' in window)) return
      this.$refs.cursor.classList.add('Zoomable_cursor_is-visible')
      document.body.style.cursor = 'none'
      window.addEventListener('mousemove', this.captureCursor)
    },
    removeCursor () {
      this.$refs.cursor.classList.remove('Zoomable_cursor_is-visible')
      window.removeEventListener('mousemove', this.captureCursor)
      document.body.style.cursor = null
    },
    captureCursor (e) {
      let x = e.clientX - 30
      let y = e.clientY - 30

      this.$refs.cursor.style.left = x + 'px'
      this.$refs.cursor.style.top = y + 'px'
    },
    /**
     * Callback lorsque l'image a fini de charger
     */
    hdImgLoadedHandler () {
      // Sécurité - si le composant a été détruit entre temps, on s'arrête là
      if (this.unmounted) return

      // On change l'attribut src de l'image avec celui de la version hd
      this.currentSrc = this._hdImgLoader.src

      this.imgRatio = this._hdImgLoader.height / this._hdImgLoader.width

      // On supprime l'image servant de loader
      this._hdImgLoader.removeEventListener('load', this.hdImgLoadedHandler)
      this._hdImgLoader = null

      // Recentre
      this.cacheData()

      const {elRect, imgWidth, imgHeight} = this,
        y = (elRect.height - imgHeight) / 2,
        x = (elRect.width - imgWidth) / 2

      // On redimensionne et repositionne l'image
      TweenLite.to(this.$refs.img, 2, {
        width: imgWidth,
        height: imgHeight
      })
    },
    /**
     * On cache les données servant au calcul du positionnement de l'image
     */
    cacheData () {
      this.thumbRect = this.thumbEl.getBoundingClientRect()
      this.elRect = this.$el.getBoundingClientRect()
      this.imgRect = this.$refs.img.getBoundingClientRect()
    },
    /**
     * Callback lorsque la fenêtre resize
     */
    windowResizeHandler () {
      this.cacheData()

      const {elRect, imgWidth, imgHeight} = this,
        y = (elRect.height - imgHeight) / 2,
        x = (elRect.width - imgWidth) / 2

      // On stop l'animation en fonction de la souris
      this.mousePos = null

      // On redimensionne et repositionne l'image
      TweenLite.to(this.$refs.img, 2, {
        top: y,
        left: x,
        width: imgWidth,
        height: imgHeight
      })
    },
    /**
     * Callback lorsqu'une touche du clavier est presée
     */
    keydownHandler (e) {
      // Si c'est la touche "echap"
      if (e.keyCode === 27) { // esc
        // On ferme la visionneuse
        this.close()
      }
    },
    /**
     * Callback au click
     */
    clickHandler (e) {
      e.preventDefault()
      // On ferme la visionneuse
      this.close()
    },
    /**
     * Callback lorsque la souris bouge
     */
    mouseMoveHandler (e) {
      this.mousePos = {
        x: e.clientX,
        y: e.clientY
      }
    },
    /**
     * Récupère la position du premier point d'un évènement touch
     *
     * @arg {TouchEvent} e - évènement touch
     *
     * @return {x,y} position du premier point de touch
     */
    getTouchPos (e) {
      const {clientX: x, clientY: y} = e.touches[0]
      return {x, y}
    },
    /**
     * Callback lorsqu'un mouvement de touch commence
     */
    touchStartHandler (e) {
      const {top, left} = this.$refs.img.getBoundingClientRect() // TODO - fix - this.imgRect not updated properly

      // On commence à écouter les mouvements de touchmove
      window.addEventListener('touchmove', this.touchMoveHandler)

      this.isDraging = true

      // On enregistre le point d'origine du mouvement touch (pour le calcul du delta)
      this._beforeDragTouchPoint = this.getTouchPos(e)

      // On enregistre la position actuelle de l'image (pour le positionnement en fonction du delta de déplacement)
      this._beforeDragImgPos = {
        x: left,
        y: top
      }

      // Permet d'éviter l'émition de mouse events !
      // voir la doc https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
      e.stopPropagation()
      e.stopImmediatePropagation()
      return false
    },
    /**
     * Callback lorsqu'un mouvement de touch s'arrête
     */
    touchEndHandler (e) {
      const {top, left, width, height} = this.$refs.img.getBoundingClientRect() // TODO - fix - this.imgRect not updated properly

      // On arrête d'écouter les mouvements de touchmove
      window.removeEventListener('touchmove', this.touchMoveHandler)

      // On repositionne l'image correctement
      // au cas où on l'ai déplacé on dehors des limites autorisées (doit couvrir le composant en mode "cover")
      TweenLite.to(this.$refs.img, 5, {
        left: Math.min(0, Math.max(left, this.elRect.width - width)),
        top: Math.min(0, Math.max(top, this.elRect.height - height))
      })

      this.isDraging = false
    },
    /**
     * Callback lorsqu'un mouvement de touch bouge
     */
    touchMoveHandler (e) {
      // On récupère le point de touch actuel
      const currentTouchPoint = this.getTouchPos(e)

      // On déplace l'image
      // Manière à ce qu'elle suive le mouvement du doigt
      TweenLite.set(this.$refs.img, {
        left: this._beforeDragImgPos.x + currentTouchPoint.x - this._beforeDragTouchPoint.x,
        top: this._beforeDragImgPos.y + currentTouchPoint.y - this._beforeDragTouchPoint.y
      })
    },
    /**
     * Action avant fermeture de la visionneuse
     */
    beforeClose () {
      // On arrête d'écouter les évènements de la souris
      window.removeEventListener('mousemove', this.mouseMoveHandler)
      window.removeEventListener('touchstart', this.touchStartHandler)
      window.removeEventListener('touchend', this.touchEndHandler)

      // permet d'arrêter l'animation de raplacement de l'image en fonction de la souris
      this.mousePos = null
    },
    /**
     * Fermeture de la visionneuse
     */
    close () {
      this.beforeClose()

      this.$emit('close')
    },
    /**
     * Callback avant l'apparition du composant
     */
    beforeEnter (pEl) {
    },
    /**
     * Animation d'apparition du composant
     */
    enter (pEl, done) {
      this.cacheData()

      // this.$nextTick(() => {
      // On calcul la taille final de l'image
      const {elRect, imgWidth, imgHeight} = this,
        y = (elRect.height - imgHeight) / 2,
        x = (elRect.width - imgWidth) / 2

        // On redimensionne et place l'image
        // en fonction du ClientRect de la thumbnail ayant ouvert la visionneuse
        // afin de créer cet effet de "zoom-in"
      TweenLite.set(this.$refs.img, {
        left: this.thumbRect.left + 'px',
        top: this.thumbRect.top + 'px',
        scale: this.thumbRect.width / imgWidth,
        width: imgWidth,
        height: imgHeight
      })

      // return

      // this.$refs.img.style.top = this.thumbRect.top + 'px'
      // this.$refs.img.style.left = this.thumbRect.left + 'px'

      // On kill ya précédente timeline au cas oü
      this.killtimeline()

      // return
      // On créer une nouvelle timeline
      this._timeline = new TimelineLite({onComplete: done})

      // On anim l'image
      // pour qu'elle apparaisse avec un effet de zoom
      // jusqu'à remplir la taille de l'écran
      this._timeline.to(this.$refs.img, 0.5, {
        top: y,
        left: x,
        scale: 1,
        width: imgWidth,
        height: imgHeight,
        ease: Power3.easeOut
      })

      // On fait apparaitre le background
      this._timeline.set(this.$refs.bg, {
        autoAlpha: 1
      })
      // })
    },
    /**
     * Callback après l'apparition du composant
     */
    afterEnter (pEl) {
      this.cacheData()

      // On écoute les évènements de la souris
      window.addEventListener('mousemove', this.mouseMoveHandler)
      window.addEventListener('touchstart', this.touchStartHandler)
      window.addEventListener('touchend', this.touchEndHandler)
    },
    /**
     * Callback avant l'animation de disparition du composant
     */
    beforeLeave (pEl) {
      // Au cas où le composant ai été fermé par le composant parant sans passer par la méthode close
      this.beforeClose()
    },
    /**
     * Animation de disparition du composant
     */
    leave (pEl, done) {
      // On kill ya précédente timeline au cas oü
      this.killtimeline()
      // On créer une nouvelle timeline
      this._timeline = new TimelineLite({onComplete: done})

      // On cache le background
      this._timeline.set(this.$refs.bg, {
        autoAlpha: 0
      })

      const {imgWidth, imgHeight} = this

      // On anim l'image
      // pour qu'elle disparaissent avec un effet de "zoom-out"
      // jusqu'à se replacer par dessus sa thumbnail
      this._timeline.to(this.$refs.img, 0.3, {
        left: this.thumbRect.left,
        top: this.thumbRect.top,
        scale: this.thumbRect.width / this.imgRect.width,
        width: imgWidth,
        height: imgHeight,
        ease: Power3.easeIn
      })
    },
    /**
     * Kill la timeline d'animation du composant
     */
    killtimeline () {
      if (this._timeline) {
        this._timeline.kill()
        this._timeline = null
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .FullscreenImgViewer
    z-index: 9990
    position: fixed
    top 0
    left 0
    right 0
    cursor none!important
    bottom 0

    &_bg
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      background-color: rgba(0,0,0,0.9)
      opacity 0

    &_img
      pointer-events none
      position absolute
      top 0
      left 0
      width: 100%
      height auto
      display block
      margin 0
      transform-origin: top left
      will-change transform

      img
        position absolute
        top 0
        left 0
        width: 100%
        height auto
        display block
        opacity 0
        transition opacity 0.8s $ease

      .active
        opacity 1

    .Zoomable_cursor

      position absolute
      pointer-events none
      top 0px
      left 0px
      height 60px
      border-radius 50%
      border 1px solid transparent
      box-sizing border-box
      width 60px
      overflow hidden
      opacity 0
      transform scale(0.3)
      transition transform 0.4s 0.2s $ease, opacity 0.2s 0.4s $ease
      background-color rgba(0,0,0,0.5)

      span

        width 2px
        background-color $beige
        top 50%
        left 50%
        transform translate(-50%, -50%) rotate(90deg)
        height 0%
        transition all 0.6s 0.4s $ease

      &_is-visible

        transform scale(1)
        opacity 1
        transition transform 0.6s $ease, opacity 0.6s 0s $ease
        border-color $beige

        span:first-child

          height 0%!important

        span

          height 45%

</style>
